import { useQuery } from "@tanstack/react-query";
import { hotelService } from "@/services/hotel-service";

import type {
  SettlementBookingType,
  SettlementSummaryMap,
} from "../types/settlementBookingSummary";

export const settlementSummaryKeys = {
  all: ["settlement-summary"] as const,
  summary: (type: SettlementBookingType, hotelId?: string) =>
    [...settlementSummaryKeys.all, type, hotelId] as const,
};

export const useSettlementSummary = <T extends SettlementBookingType>(
  type: T,
  hotelId?: string,
) => {
  return useQuery<SettlementSummaryMap[T] | null>({
    queryKey: settlementSummaryKeys.summary(type, hotelId),
    queryFn: () => hotelService.getSettlementSummary(type, hotelId),
    enabled: !!hotelId,
  });
};

export const useArrivalsSummary = (hotelId?: string) => {
  return useSettlementSummary("Arrivals", hotelId);
};

export const useInHouseSummary = (hotelId?: string) => {
  return useSettlementSummary("In-House", hotelId);
};

export const useDeparturesSummary = (hotelId?: string) => {
  return useSettlementSummary("Departures", hotelId);
};
